import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Columns } from "../columns/colunms.entity";
import { Level } from "../level/level.entity";
import { Locations } from "../locations/location.entity";
import { RackZoneMapping } from "../rack-zone-mapping/rack-zone-mapping-entity";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";

@Entity('zone_master')
export class ZoneMaster {

  @PrimaryGeneratedColumn("increment", { name: 'zone_id' })
  zoneId: number;

  @Column("char", {
    nullable: false,
    length: 20,
    name: "zone_code"
  })
  @Index({ unique: true })
  zoneCode: string;
  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "zone_name"
  })
  //   @Index({unique:true})
  zoneName: string;

  @Column('integer', {
    nullable: true,
    name: 'plant_id'
  })
  plantId: number;
 
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  @OneToMany(type => Rack, racks => racks.zoneMasterInfo)
  racksInfo: Rack[];
  
  @OneToMany(type => RackZoneMapping, rack => rack.rackInfo)
  rackZoneInfo: RackZoneMapping[];

  @OneToMany(type => Locations, lev => lev.zoneMasterInfo)
  locationsInfo: Locations[];

}
